import React from 'react';

require('../../css/components/FooterNav.scss');

'use strict';

export default class FooterNav extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
                <nav className="navbar fixed-bottom footer-mobile navbar-light bg-light">
                    <div className="container">
                        <div className="footer-button">
                            <a className={"footer-button-image home-button" + (this.props.activeSection === "Home" ? " active" : "")} href={this.props.homeUrl} title={this.props.home} />
                            <span>{this.props.home}</span>
                        </div>

                        {this.props.userNotifications || this.props.hideRecommendations ? null :
                            <div className="footer-button">
                                <a className={"footer-button-image recommended-button" + (this.props.activeSection === "Recommended" ? " active" : "")} href={this.props.recommendedUrl} title={this.props.recommended} />
                                <span>{this.props.recommended}</span>
                            </div>
                        }

                        {this.props.userNotifications ? null :
                            <div className="footer-button">
                                <a className={"footer-button-image library-button" + (this.props.activeSection === "Library" ? " active" : "")} href={this.props.libraryUrl} title={this.props.library} />
                                <span>{this.props.library}</span>
                            </div>
                        }

                        {this.props.user ?
                            <div className="footer-button">
                                <div style={{ position: "relative" }}>
                                    <a className={"footer-button-image user-button" + (this.props.activeSection === "User" ? " active" : "")} href={this.props.userUrl} title={this.props.user}>
                                        {this.props.userNotifications ?
                                            <span className="badge">
                                                {this.props.userNotifications}
                                            </span> : null
                                        }
                                    </a>
                                </div>
                                <span>{this.props.user}</span>
                            </div> : null
                        }
                    </div>
                </nav>
        );
    }
}